import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { UserRound } from "lucide-react";
import { IoLogOut, IoSettingsOutline } from "react-icons/io5";
import Avatar from "../assets/avatar.png";
import { resetAnalyticsUser } from "../helpers/analytics";
import { useProfile } from "../hooks/useProfile";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "./ui/dropdown-menu";

type AccountMenuProps = {
	className?: string;
};

export const AccountMenu = ({ className }: AccountMenuProps) => {
	const navigate = useNavigate();
	const { logout, user } = useAuth0();
	const { profile } = useProfile();

	if (!user) {
		return null;
	}

	const handleLogout = () => {
		resetAnalyticsUser();
		logout({
			returnTo: window.location.origin,
		});
	};

	const accountName = profile
		? `${profile.firstName} ${profile.lastName}`.trim()
		: user.name || user.nickname || "Account";
	const accountEmail = profile?.email || user.email;
	const accountImage = user.picture || Avatar;

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<button
					type="button"
					className={
						className ||
						"flex items-center justify-center rounded-full outline-none ring-offset-background transition-opacity hover:opacity-90 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
					}
					aria-label="Open account menu"
				>
					<img
						src={accountImage}
						alt={`${accountName} avatar`}
						className="w-8 h-8 rounded-full object-cover border border-[#E4E4E4]"
					/>
				</button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-64">
				<DropdownMenuLabel className="py-3">
					<div className="flex flex-col gap-1">
						<p className="text-sm font-semibold text-[#121212]">{accountName}</p>
						{accountEmail && (
							<p className="text-xs font-normal text-[#6E6E6E]">{accountEmail}</p>
						)}
					</div>
				</DropdownMenuLabel>
				<DropdownMenuSeparator />
				<DropdownMenuItem onClick={() => navigate("/my-laborpass")}>
					<UserRound />
					My LaborPass
				</DropdownMenuItem>
				<DropdownMenuItem onClick={() => navigate("/settings")}>
					<IoSettingsOutline />
					Settings
				</DropdownMenuItem>
				<DropdownMenuSeparator />
				<DropdownMenuItem onClick={handleLogout}>
					<IoLogOut style={{ transform: "rotate(180deg)" }} />
					Logout
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
